import * as ls from 'local-storage';
import { find } from 'lodash';
import moment from 'moment';

import {
  STORAGE_TOKEN,
  STORAGE_IDLE_TIME_UTC,
  SESSION_LENGTH_MINUTES,
  STORAGE_FORCE_LOG_OUT,
} from 'Common/Constants';
import { token } from 'API/MPWApi';

export const isSessionExpired = (timeWentIdle, currentUTC) => {
  return timeWentIdle &&
    currentUTC.isAfter(
      moment.utc(timeWentIdle).add(SESSION_LENGTH_MINUTES, 'm')
    )
    ? true
    : false;
};

export const logOutUser = (history, rememberLastUrl) => {
  token.fill({});
  ls.remove(STORAGE_TOKEN);
  ls.remove(STORAGE_IDLE_TIME_UTC);
  ls.set(STORAGE_FORCE_LOG_OUT, true);
  if (history) {
    const { pathname } = window.location;
    const blacklist = ['/home', '/notfound', '/'];
    const redirect =
      !blacklist.find(r => r === pathname) && rememberLastUrl
        ? `?r=${encodeURIComponent(pathname)}`
        : '';
    history.replace(`/${redirect}`);
  }
};

export const setIdleTime = value => {
  ls.set(STORAGE_IDLE_TIME_UTC, value);
};

/**
 * @param {Array} accessInfo
 * @param {String} currentPageUrl
 *
 * @returns {Boolean}
 */
export const checkAccessInfo = (accessInfo, currentPageUrl) => {
  if (
    !accessInfo ||
    !currentPageUrl ||
    currentPageUrl.length === 0 ||
    accessInfo.length === 0
  ) {
    return false;
  }

  //Note: /home is never in access info, we should allowed logged in users to access this always
  currentPageUrl = currentPageUrl.toLowerCase();

  if (
    currentPageUrl === '/home' ||
    currentPageUrl === '/notfound' ||
    currentPageUrl === '/userprofile'
  ) {
    return true;
  }

  return find(accessInfo, x => {
    const parts = currentPageUrl.substring(1).split('/');

    return (
      x.PathUrlSegment && x.PathUrlSegment.toLowerCase() === `/${parts[0]}`
    );
  })
    ? true
    : false;
};

/**
 * @param {Array} data
 * @return {Array}
 */
export const extractPreferencesFromAccessInfo = (data = []) =>
  data.filter(item => item.AccessInfoId);

/**
 *
 * @param {Number} id
 * @param {Array} preferences
 * @returns {Boolean}
 */
export const isPreferenceEnabled = (id, preferences) => {
  return preferences.some(item => item.Id === id && item.WriteAccess);
};

/**
 *
 * @param {Number} id
 * @param {Array} preferences
 * @returns {Boolean}
 */
export const isPreferenceDisabled = (id, preferences) => {
  return !isPreferenceEnabled(id, preferences);
};

/**
 * @param {Number} accessInfoId
 * @param {Number} productId
 *
 * @returns {Boolean}
 */
export const hasAccess = (accessInfoId, productId, accessInfo) => {
  function isInAccessInfo(element) {
    return element.Id === accessInfoId && element.ProductId === productId;
  }

  return accessInfo.some(isInAccessInfo);
};



// WEBPACK FOOTER //
// ./src/common/Security/SecurityHelpers.js